export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/bboxMergerWorker.c426fe2c.worker.js");
}
